

































































































import InsuranceCommissionList from "./list/InsuranceCommissionList.vue";
import OfferItemCommissionList from "./list/OfferItemCommissionList.vue";
import ServiceFeeCommissionList from "./list/ServiceFeeCommissionList.vue";
import AccommodationCommissionList from "./list/AccommodationCommissionList.vue";
import { Component, Vue } from 'vue-property-decorator';
import { IReqFilterTable } from '@/interface/common';
import { totalCommissionApi, receivedPaymentApi } from '@/api/index';

@Component({
  name: 'receivedComponent',
  components: {
    InsuranceCommissionList,
    OfferItemCommissionList,
    ServiceFeeCommissionList,
    AccommodationCommissionList,
  }
})
export default class extends Vue {
  public datas: any = [];
  public totalCommission: any = {};

  public tablePage: IReqFilterTable<any> = {
    currentPage: 1, // 查询页码
    showCount: 20, // 显示条目数
    totalResult: 0, // 总数
  }

  public formatDate(date: any) {
    if (date) {
      const ym = date.split(" ")[0];
      const ymArr = ym.split("-");
      return `${ymArr[0]}${ymArr[1]}`;
    }
    return "";
  }

  // 未结算佣金
  public async getDatas() {
    try {
      const params = Object.assign({}, this.tablePage);
      const { data } = await receivedPaymentApi(params);
      this.datas = data.datas;
      this.tablePage = Object.assign({}, data.page);
      this.getTotalCommission();
    } catch(err) {
      //
    }
  }

  public async getTotalCommission() {
    try {
      const { data } = await totalCommissionApi();
      this.totalCommission = data.data;
    } catch(err) {
      //
    }
  }

  public handleSizeChange(pageSize: number) {
    this.tablePage.showCount = pageSize;
    this.getDatas();
  }

  public handleCurrentChange(currentPage: number) {
    this.tablePage.currentPage = currentPage;
    this.getDatas();
  }
}
